import { Link } from 'react-router-dom';
import { SidebarMenuButton, SidebarMenuItem } from '@src/design-system/sidebar';
import { useIsActiveUrl } from './hooks';
import type { TNavLink } from './types';
import { NavLinkBadge } from './nav-link-badge';

export const NavLinkWithoutChildren = ({ item }: { item: TNavLink }) => {
  const isActiveUrl = useIsActiveUrl();
  const isMenuItemActive = isActiveUrl(item.url);

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        isActive={!!isMenuItemActive}
        tooltip={item.title}
        asChild
      >
        <Link
          to={'url' in item && item.url ? item.url : '/'}
          className='[&>svg]:size-5 shrink-0'
        >
          {isMenuItemActive && item.icon ? (
            <item.icon variant='Bold' />
          ) : item.icon ? (
            <item.icon />
          ) : null}
          <div className='flex items-center gap-2'>
            <span>{item.title}</span>
            <NavLinkBadge item={item} />
          </div>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
